import React from 'react';
import { Pill } from '@amount/frontend-components';

import { InfoText } from '../../common';
import { formatDate } from '../../../../../util/date';
import { ICreditCardProps, ProductHeader } from '../common';

const title = ({product: { creditCard }}: ICreditCardProps) =>
  `Credit Card${creditCard ? ` ${creditCard.lastFour}` : ''}`;

const pill = () => (
  <Pill pillColor={'secondary'}>Active</Pill>
);

const info = ({ product: { createdAt }}: ICreditCardProps) =>
  `Issued ${formatDate(createdAt)}`;

export const CreditCardDescription: React.FC<ICreditCardProps> = props => {
  const { product: { id } } = props;

  return (
    <>
      <ProductHeader>
        <strong>{title(props)}</strong>{pill()}
      </ProductHeader>
      <InfoText>{info(props)}</InfoText>
      <InfoText>ID #{id}</InfoText>
    </>
  );
};
